(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvDocumentTemplateEditorPdf', drvDocumentTemplateEditorPdf);

    drvDocumentTemplateEditorPdf.$inject = ['$q', 'DialogService'];
    
    /**
     * @ngdoc directive
     * @name drvDocumentTemplateEditorPdf
     *
     * @description
     * Editor for PDF document template.
     *
     * # Scope Params
     * {Blob} document
     * {DocumentTemplate} documentTemplate
     * {TestMerge} testMerge
     * {Bool} readonly - In readonly mode, the document cannot be edited
     * {object} entityTemplate
     */
    function drvDocumentTemplateEditorPdf($q, DialogService) {
        var directive = {
            controller: DocumentTemplateEditorPdfCtrl,
            controllerAs: 'vm',
            restrict: 'EA',
            scope: {},
            bindToController: {
                document: '<',
                documentTemplate: '=',
                testMerge: '<?',
                readonly: '<?',
                entityTemplate: '<'
            },
            template:
                '<drv-document-template-editor-pdf-toolbar' +
                ' pdf-render-api="vm.pdfRenderApi"' +
                ' selected-pdf-elements="vm.selectedPdfElements"' +
                ' interaction-mode="vm.interactionMode"' +
                ' document-template="vm.documentTemplate"' +
                ' test-merge="vm.testMerge"' +
                ' sticky-element' +
                ' scale="vm.scale">' +
                '</drv-document-template-editor-pdf-toolbar>' +

                '<drv-pdf-render' +
                ' document="vm.documentArray"' +
                ' scale="vm.scale"'+
                ' pdf-elements="vm.pdfElements"' +
                ' selected-pdf-elements="vm.selectedPdfElements"' +
                ' read-only-mode="vm.readonly"' +
                ' api="vm.pdfRenderApi"' +
                ' interaction-mode="vm.interactionMode"' +
                ' default-font="vm.documentTemplate.data.AdvancedSettings.DefaultFont"' +
                ' context-menu-templates="vm.contextMenuTemplates"' +
                ' zoom-presets="vm.zoomPresets"' +
                ' on-open-properties-dialog="vm.onOpenPropertiesDialog()" >' +
                '</drv-pdf-render>'
        };

        DocumentTemplateEditorPdfCtrl.$inject = ['$scope'];

        return directive;

        function DocumentTemplateEditorPdfCtrl($scope) {
            var vm = this;
            vm.pdfRenderApi = {};
            vm.zoomPresets = [];
            vm.scale = 1.5;
            vm.documentArray = null;
            vm.pdfElements = [];
            vm.selectedPdfElements = [];
            vm.contextMenuTemplates = {
                textElement: { templateUrl: 'app/DocumentTemplate/PDF/context-menu-text-element.tmpl.html' },
                tickBoxElement: { templateUrl: 'app/DocumentTemplate/PDF/context-menu-tick-box-element.tmpl.html' },
                imageElement: { templateUrl: 'app/DocumentTemplate/PDF/context-menu-image-element.tmpl.html' },
                multipleElements: { templateUrl: 'app/DocumentTemplate/PDF/context-menu-multiple-elements.tmpl.html' },
                noSelection: { templateUrl: 'app/DocumentTemplate/PDF/context-menu-no-selection.tmpl.html' }
            };
            vm.onOpenPropertiesDialog = onOpenPropertiesDialog;

            $scope.$watch('vm.document', function (newVal, oldVal) {
                if (newVal === undefined || newVal === null) {
                    vm.documentArray = null;
                } else {
                    convertBlobToUint8Array(newVal).then(function (data) {
                        vm.documentArray = data;
                    });
                }
            });

            $scope.$watch('vm.documentTemplate.data.AdvancedSettings.PdfInsertionDetails', function (newVal) {
                var convertedElements = convertPdfInsertionDetailsToPdfElements(newVal);

                var selectedIndexes = [];
                angular.forEach(vm.selectedPdfElements, function (selectedElement) {
                    var selectedIndex = vm.pdfElements.indexOf(selectedElement);
                    if (selectedIndex !== -1) {
                        selectedIndexes.push(selectedIndex);
                    }
                });

                vm.pdfElements.length = 0;
                angular.forEach(convertedElements, function (element) {
                    vm.pdfElements.push(element);
                });

                // Need to recreate the list of selected elements because the elements have been re-created.
                vm.selectedPdfElements.length = 0;
                angular.forEach(selectedIndexes, function (idx) {
                    if (idx < vm.pdfElements.length) {
                        vm.selectedPdfElements.push(vm.pdfElements[idx]);
                    }
                });
            }, true);

            $scope.$watch('vm.pdfElements', function (newVal) {
                var convertedElements = convertPdfElementsToPdfInsertionDetails(newVal);

                if (angular.isDefined(vm.documentTemplate) && angular.isDefined(vm.documentTemplate.data)) {
                    if (angular.isUndefined(vm.documentTemplate.data.AdvancedSettings)) {
                        vm.documentTemplate.data.AdvancedSettings = {};
                    }

                    if (angular.isUndefined(vm.documentTemplate.data.AdvancedSettings.PdfInsertionDetails)) {
                        vm.documentTemplate.data.AdvancedSettings.PdfInsertionDetails = [];
                    }

                    vm.documentTemplate.data.AdvancedSettings.PdfInsertionDetails.length = 0;
                    angular.forEach(convertedElements, function (element) {
                        vm.documentTemplate.data.AdvancedSettings.PdfInsertionDetails.push(element);
                    });
                }
            }, true);

            function onOpenPropertiesDialog() {
                var dialogTemplateUrl = null;

                if (vm.selectedPdfElements[0] instanceof PDFedit.elements.PdfTextElement) {
                    dialogTemplateUrl = 'app/DocumentTemplate/PDF/document-template-editor-pdf-textbox-properties-dialog.tmpl.html';
                } else if (vm.selectedPdfElements[0] instanceof PDFedit.elements.PdfTickBoxElement) {
                    dialogTemplateUrl = 'app/DocumentTemplate/PDF/document-template-editor-pdf-tickbox-properties-dialog.tmpl.html';
                } else if (vm.selectedPdfElements[0] instanceof PDFedit.elements.PdfImageElement) {
                    dialogTemplateUrl = 'app/DocumentTemplate/PDF/document-template-editor-pdf-image-properties-dialog.tmpl.html';
                }

                if (dialogTemplateUrl !== null) {
                    DialogService.show({
                        locals: {
                            selectedPdfElements: vm.selectedPdfElements,
                            entityTemplate: vm.entityTemplate
                        },
                        controller: 'DocumentTemplateEditorPdfTextboxPropertiesDialogCtrl',
                        controllerAs: 'vm',
                        templateUrl: dialogTemplateUrl
                    });
                }
            }
        }


        /**
         * ChilliDocs persists PDF elements as a list of ChilliDocs.Models.DocumentTemplate.PdfInsertion,
         * while the PDF editor uses PDFedit.elements.PdfElement JS objects.
         *
         * This function converts ChilliDocs format to PDFedit format.
         *
         * @param {Array} pdfInsertionDetails - Array of ChilliDocs.Models.DocumentTemplate.PdfInsertion objects
         * @returns {Array} Array of PDFedit.elements.PdfElement JS objects
         */
        function convertPdfInsertionDetailsToPdfElements(pdfInsertionDetails) {
            var pdfElements = [];

            angular.forEach(pdfInsertionDetails, function (insertDetail) {
                var element = null;

                switch (insertDetail.Type) {
                    case 'Text':
                        element = new PDFedit.elements.PdfTextElement();
                        element.characterCount = insertDetail.CharacterCount || 0;
                        element.characterSpacings = insertDetail.CharacterSpacings || [];
                        element.fontSize = insertDetail.FontSize;
                        element.fontName = insertDetail.FontName;
                        element.fontColour = insertDetail.FontColourHex;
                        element.fontBold = insertDetail.FontBold;
                        element.fontItalic = insertDetail.FontItalic;
                        break;
                    case 'CheckBox':
                        element = new PDFedit.elements.PdfTickBoxElement();
                        element.comparisonValue = insertDetail.ComparisonValue;
                        element.tickStyle = insertDetail.TickStyle;
                        break;
                    case 'Image':
                        element = new PDFedit.elements.PdfImageElement();
                        break;
                }

                if (element !== null) {
                    element.placeHolder = insertDetail.FieldKey;
                    element.x = insertDetail.PositionX;
                    element.y = insertDetail.PositionY;
                    element.width = insertDetail.Width || 100;
                    element.height = insertDetail.Height || insertDetail.FontSize * 2;
                    element.pageNumber = insertDetail.PageNum;

                    pdfElements.push(element);
                }
            });

            return pdfElements;
        }

        /**
         * ChilliDocs persists PDF elements as a list of ChilliDocs.Models.DocumentTemplate.PdfInsertion,
         * while the PDF editor uses PDFedit.elements.PdfElement JS objects.
         *
         * This function converts PDFedit format to ChilliDocs format.
         *
         * @param {Array} Array of PDFedit.elements.PdfElement JS objects
         * @returns {Array} pdfInsertionDetails - Array of ChilliDocs.Models.DocumentTemplate.PdfInsertion objects
         */
        function convertPdfElementsToPdfInsertionDetails(pdfElements) {
            var insertionDetails = [];

            angular.forEach(pdfElements, function (element) {
                var detail = {};
                detail.FieldKey = element.placeHolder;
                detail.PageNum = element.pageNumber;
                detail.PositionX = element.x;
                detail.PositionY = element.y;
                detail.Width = element.width;
                detail.Height = element.height;

                if (element instanceof PDFedit.elements.PdfTextElement) {
                    detail.Type = 'Text';
                    detail.CharacterCount = element.characterCount;
                    detail.CharacterSpacings = element.characterSpacings;
                    detail.FontColourHex = element.fontColour;
                    detail.FontBold = element.fontBold;
                    detail.FontItalic = element.fontItalic;
                    detail.FontName = element.fontName;
                    detail.FontSize = element.fontSize;
                } else if (element instanceof PDFedit.elements.PdfTickBoxElement) {
                    detail.Type = 'CheckBox';
                    detail.ComparisonValue = element.comparisonValue;
                    detail.TickStyle = element.tickStyle;
                } else if (element instanceof PDFedit.elements.PdfImageElement) {
                    detail.Type = 'Image';
                }

                insertionDetails.push(detail);
            });

            return insertionDetails;
        }

        /**
         * Convert a Blob object to Uint8Array.
         *
         * @param {Blob} blob
         * @returns {Promise} A promise that resolves a {Uint8Array}
         */
        function convertBlobToUint8Array(blob) {
            var blobDefer = $q.defer();

            var blobReader = new FileReader();
            blobReader.onload = function () {
                blobDefer.resolve(this);
            };
            blobReader.readAsArrayBuffer(blob);

            return blobDefer.promise.then(function (data) {
                return new Uint8Array(data.result);
            });
        }
    }
})();